"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsClient = void 0;
const client_1 = require("@leid/client");
class ProductsClient extends client_1.ClientBase {
    // Price Groups
    async getPriceGroups(filter) {
        try {
            const response = await this.httpClient.get('/price-groups', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPriceGroups error on a call', filter);
        }
    }
    async getPriceGroup(id) {
        try {
            const response = await this.httpClient.get(`/price-groups/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPriceGroup error on a call', id);
        }
    }
    async createPriceGroup(priceGroup) {
        try {
            const response = await this.httpClient.post('/price-groups', priceGroup);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createPriceGroup error on a call', priceGroup);
        }
    }
    async updatePriceGroup(id, priceGroup) {
        try {
            const response = await this.httpClient.put(`/price-groups/${id}`, priceGroup);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updatePriceGroup error on a call', id, priceGroup);
        }
    }
    // Pricings
    async getPricings(filter) {
        try {
            const response = await this.httpClient.get('/pricings', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPricings error on a call', filter);
        }
    }
    async getPricing(id) {
        try {
            const response = await this.httpClient.get(`/pricings/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPricing error on a call', id);
        }
    }
    async createPricing(pricing) {
        try {
            const response = await this.httpClient.post('/pricings', pricing);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createPricing error on a call', pricing);
        }
    }
    async updatePricing(id, pricing) {
        try {
            const response = await this.httpClient.put(`/pricings/${id}`, pricing);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updatePricing error on a call', id, pricing);
        }
    }
    // Products
    async getProducts(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/products', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProducts error on a call', filter, sortingData);
        }
    }
    async getProduct(id) {
        try {
            const response = await this.httpClient.get(`/products/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProduct error on a call', id);
        }
    }
    async getProductTechnicalDetails(productId) {
        try {
            const response = await this.httpClient.get(`/products/${productId}/technical-details`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductTechnicalDetails error on a call', productId);
        }
    }
    async createProduct(product) {
        try {
            const response = await this.httpClient.post('/products', product);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createProduct error on a call', product);
        }
    }
    async updateProduct(id, product) {
        try {
            const response = await this.httpClient.put(`/products/${id}`, product);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateProduct error on a call', id, product);
        }
    }
    async updateProductTechnicalDetails(productId, technicalDetails) {
        try {
            const response = await this.httpClient.put(`/products/${productId}/technical-details`, technicalDetails);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateProductTechnicalDetails error on a call', productId, technicalDetails);
        }
    }
    async updateProductStock(id, difference) {
        try {
            const response = await this.httpClient.patch(`/products/${id}/stock/${difference}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateProductStock error on a call', id, difference);
        }
    }
    // Product Categories
    async getProductCategories(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/product-categories', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductCategories error on a call', filter);
        }
    }
    async getProductCategory(id) {
        try {
            const response = await this.httpClient.get(`/product-categories/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductCategory error on a call', id);
        }
    }
    async createProductCategory(productCategory) {
        try {
            const response = await this.httpClient.post('/product-categories', productCategory);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createProductCategory error on a call', productCategory);
        }
    }
    async updateProductCategory(id, productCategory) {
        try {
            const response = await this.httpClient.put(`/product-categories/${id}`, productCategory);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateProductCategory error on a call', id, productCategory);
        }
    }
    // ====== Manufacturers ======
    async getManufacturers(filter) {
        try {
            const response = await this.httpClient.get('/manufacturers', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getManufacturers error on a call', filter);
        }
    }
    async getManufacturer(id) {
        try {
            const response = await this.httpClient.get(`/manufacturers/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getManufacturer error on a call', id);
        }
    }
    async createManufacturer(manufacturer) {
        try {
            const response = await this.httpClient.post('/manufacturers', manufacturer);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createManufacturer error on a call', manufacturer);
        }
    }
    async updateManufacturer(id, manufacturer) {
        try {
            const response = await this.httpClient.put(`/manufacturers/${id}`, manufacturer);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateManufacturer error on a call', id, manufacturer);
        }
    }
    // ====== Product Models ======
    async getProductModels(filter) {
        try {
            const response = await this.httpClient.get('/product-models', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductModels error on a call', filter);
        }
    }
    async getProductModel(id) {
        try {
            const response = await this.httpClient.get(`/product-models/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductModel error on a call', id);
        }
    }
    async createProductModel(productModel) {
        try {
            const response = await this.httpClient.post('/product-models', productModel);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createProductModel error on a call', productModel);
        }
    }
    async updateProductModel(id, productModel) {
        try {
            const response = await this.httpClient.put(`/product-models/${id}`, productModel);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateProductModel error on a call', id, productModel);
        }
    }
    // ====== Image Sequence ======
    async getImageSequences(filter) {
        try {
            const response = await this.httpClient.get('/image-sequences', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getImageSequences error on a call', filter);
        }
    }
    async getImageSequence(id) {
        try {
            const response = await this.httpClient.get(`/image-sequences/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getImageSequence error on a call', id);
        }
    }
    async createImageSequence(imageSequence) {
        try {
            const response = await this.httpClient.post('/image-sequences', imageSequence);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createImageSequence error on a call', imageSequence);
        }
    }
    async updateImageSequence(id, imageSequence) {
        try {
            const response = await this.httpClient.put(`/image-sequences/${id}`, imageSequence);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateImageSequence error on a call', id, imageSequence);
        }
    }
    // ====== Image Sequence Step ======
    async getImageSequenceSteps(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/image-sequence-steps', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getImageSequenceSteps error on a call', filter);
        }
    }
    async getImageSequenceStep(id) {
        try {
            const response = await this.httpClient.get(`/image-sequence-steps/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getImageSequenceStep error on a call', id);
        }
    }
    async createImageSequenceStep(imageSequenceStep) {
        try {
            const response = await this.httpClient.post('/image-sequence-steps', imageSequenceStep);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createImageSequenceStep error on a call', imageSequenceStep);
        }
    }
    async updateImageSequenceStep(id, imageSequenceStep) {
        try {
            const response = await this.httpClient.put(`/image-sequence-steps/${id}`, imageSequenceStep);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateImageSequenceStep error on a call', id, imageSequenceStep);
        }
    }
}
exports.ProductsClient = ProductsClient;
